import React, { useMemo } from "react";
import {
    useReactTable,
    getCoreRowModel,
    getPaginationRowModel,
    getSortedRowModel,
    flexRender,
} from "@tanstack/react-table";

const Infotable1 = ({ data }) => {
    const tableData = useMemo(() => (Array.isArray(data) ? data : []), [data]);

    const columns = useMemo(
        () => [
            {
                accessorFn: (row, index) => index + 1,
                id: "srNo",
                header: "#",
                cell: (info) => (
                    <div className="text-center">{info.getValue()}</div>
                ),
            },
            {
                accessorFn: (row) => row.id ?? "N/A",
                id: "dealer_code",
                header: "Dealer Code",
                cell: (info) => (
                    <div className="text-center font-bold">{info.getValue()}</div>
                ),
            },
            {
                accessorKey: "dealer_name",
                header: "Dealer Name",
                cell: (info) => (
                    <div className=" font-bold">{info.getValue()}</div>
                ),
            },
        ],
        []
    );

    const table = useReactTable({
        data: tableData,
        columns,
        getCoreRowModel: getCoreRowModel(),
        getSortedRowModel: getSortedRowModel(),
        getPaginationRowModel: getPaginationRowModel(),
    });

    if (!data || !Array.isArray(data) || data.length === 0) {
        return (
            <div className="p-4 text-center text-gray-500">
                No data available
            </div>
        );
    }

    return (
        <div className="p-4 max-h-[400px] overflow-y-auto">
            <table className="min-w-full border-collapse border border-[#2B76AD]">
                <thead className="bg-[#2B76AD] text-white sticky top-0 z-10">
                    {table.getHeaderGroups().map((headerGroup) => (
                        <tr key={headerGroup.id}>
                            {headerGroup.headers.map((header) => (
                                <th
                                    key={header.id}
                                    className="border border-white px-4 py-3 text-center text-sm font-medium tracking-wider cursor-pointer select-none"
                                    onClick={header.column.getToggleSortingHandler()}
                                >
                                    {flexRender(
                                        header.column.columnDef.header,
                                        header.getContext()
                                    )}
                                    {header.column.getIsSorted() === "asc"
                                        ? " 🔼"
                                        : header.column.getIsSorted() === "desc"
                                            ? " 🔽"
                                            : null}
                                </th>
                            ))}
                        </tr>
                    ))}
                </thead>
                <tbody>
                    {table.getRowModel().rows.length > 0 ? (
                        table.getRowModel().rows.map((row) => (
                            <tr
                                key={row.id}
                                className="odd:bg-white text-center even:bg-gray-100"
                            >
                                {row.getVisibleCells().map((cell) => (
                                    <td
                                        key={cell.id}
                                        className="border border-gray-300 px-4 py-2 text-sm text-center"
                                    >
                                        {flexRender(cell.column.columnDef.cell, cell.getContext())}
                                    </td>
                                ))}
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td
                                colSpan={columns.length}
                                className="text-center py-4 text-gray-500 border border-gray-300"
                            >
                                No data available
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    );
};

export default Infotable1;